<script setup lang="ts">
import GoodMedal from "~/components/images/GoodMedal.vue";
import GreatMedal from "~/components/images/GreatMedal.vue";
import PerfectMedal from "~/components/images/PerfectMedal.vue";
import type {FusionSharedDtosMoodleStudentPerformanceResponseDto} from "~/types/api/api";

const props = defineProps<{
  title: string;
  goodText: string;
  greatText: string;
  emptyText: string;
  perfectText: string;
  items: FusionSharedDtosMoodleStudentPerformanceResponseDto[];
}>()

const avgPerformance = computed(() => {
  if (props.items.length == 0) return 0;

  let sumGrade = 0;
  let sumStudentGrade = 0;
  props.items.forEach(p => {
    sumStudentGrade = sumStudentGrade + (p.maxGrade || 0);
    sumGrade = sumGrade + (p.maxGrade || 0);
  })

  return Math.ceil((sumGrade / (sumStudentGrade || 1)) * 100);
});

const performance = computed(() => {
  if (avgPerformance.value > 70) return 3;
  else if (avgPerformance.value >= 40 && avgPerformance.value <= 70) return 2;
  else return 1;
})
</script>

<template>
  <VCard elevation="3" class="mb-4 performance-result-card">
    <VCardItem class="pb-6">
      <VCardTitle>{{ title }}</VCardTitle>
    </VCardItem>
    <VCardText v-if="items.length == 0">
      <p>{{ emptyText }}</p>
    </VCardText>
    <VCardText v-else class="d-flex justify-space-between">
      <div :class="['grade-section', { 'selected': performance == 3 }]">
        <PerfectMedal class="grade-icon"/>
        <span>{{ perfectText }}</span>
      </div>
      <div :class="['grade-section', { 'selected': performance == 2 }]">
        <GreatMedal class="grade-icon"/>
        <span>{{ greatText }}</span>
      </div>
      <div :class="['grade-section', { 'selected': performance == 1 }]">
        <GoodMedal class="grade-icon"/>
        <span>{{ goodText }}</span>
      </div>
    </VCardText>
  </VCard>
</template>
